const fragment = `
  id
  name
  rate
  cities {
    id
    name
    state
    description
    longDescription
    defaultImageUrl
  }
  type
  communities {
   id
   name
  }
  projects {
   id
   name
  }        
  lastModifiedLog {
    id
    initialValue
    finalValue
    maker {
      id
      name
      role
    }
  }
  creator {
    id
    name
    role
  }    
`;

export const listTaxRatesQuery = `
  query listTaxRates(
    $filter: TaxRateFilterInput
  ) {
    items: listTaxRates(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getTaxRateQuery = `
  query GetTaxRate($id: Int!) {
    item: getTaxRate(id: $id) {
      ${fragment}
    }
  }
`;

export const createTaxRateQuery = `
  mutation CreateTaxRate(
    $input: CreateTaxRateInput!
  ) {
    item: createTaxRate(input: $input) {
      ${fragment}
    }
  }
`;

export const updateTaxRateQuery = `
  mutation UpdateTaxRate(
    $input: UpdateTaxRateInput!
  ) {
    item: updateTaxRate(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteTaxRateQuery = `
  mutation DeleteTaxRate(
    $id: Int!
  ) {
    item: deleteTaxRate(id: $id) {
      ${fragment}
    }
  }
`;
